import { Response } from 'src/api/hydraResponse';
import { ISaveUserData, IUsersUpsertInitial, IUserCreateValidation } from 'src/typings/usersManage';
import { httpService } from 'src/services';
import { ApiUrl } from 'src/constants';
import { HttpMethod } from 'src/typings/app';

export function getInitial(token: string = '', url: string, params?: object): Promise<Response<IUsersUpsertInitial>> {
  return httpService.get(url, params, {
    Authorization: `Bearer ${token}`,
  });
}

export function saveUsers(token: string = '', userData: ISaveUserData, method: HttpMethod): Promise<Response<IUserCreateValidation>> {
  return httpService[method](`${ApiUrl.getApiUrl().changeUserState}`, userData, {
    Authorization: `Bearer ${token}`,
  });
}
